/**
 * Reportes de datos de prospección que requieren acción de superadmin sobre
 * `prospeccion_puntos` (los errores de dirección/unidades/año NO pasan por acá:
 * el comercial los corrige directo en la ficha — ver datosEdificio.js).
 */
export const REPORTE_TIPOS = [
  { value: "duplicado", label: "Padrón duplicado" },
  { value: "otro", label: "Otro problema del dato" },
];

export const REPORTE_TIPO_LABELS = Object.fromEntries(REPORTE_TIPOS.map((t) => [t.value, t.label]));
